import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';

import damDeviceService from '../services/dam/damDeviceService';
import log from '../services/logger/log';
import {
    selectIotDeviceConnected,
    selectIsDeviceConnectInProgress,
    selectIsDeviceSyncInProgress,
} from '../state/selectors/iotDevices';
import {selectIsOnboardingInProgress} from '../state/selectors/session';

const useSyncDevice = (dusn) => {
    const isDeviceConnectInProgress = useSelector(selectIsDeviceConnectInProgress(dusn));
    const isDeviceSyncInProgress = useSelector(selectIsDeviceSyncInProgress(dusn));
    const isDeviceConnected = useSelector(selectIotDeviceConnected(dusn));
    const [isSyncPending, setIsSyncPending] = useState(false);
    const isOnboardingInProgress = useSelector(selectIsOnboardingInProgress);

    const startAutoSync = () => {
        if (!isDeviceConnected || isDeviceConnectInProgress || isDeviceSyncInProgress) return;

        if (isOnboardingInProgress) {
            log.info(
                `useSyncDevice: Auto-sync is disabled (onboarding in progress), pending to be enabled, dusn: ${dusn}`
            );

            setIsSyncPending(true);
            return;
        }

        log.info(`useSyncDevice: Auto-sync started, dusn: ${dusn}`);

        damDeviceService.synchronizeDevice(dusn, {isNeedRetry: true});
    };

    useEffect(() => {
        startAutoSync();
    }, [isDeviceConnected]);

    // Start sync when onboarding completes
    useEffect(() => {
        if (!isOnboardingInProgress && isSyncPending) {
            log.info(`useSyncDevice: Auto-sync is enabled after onboarding, dusn: ${dusn}`);
            startAutoSync();
        }
    }, [isOnboardingInProgress]);

    // Clear sync pending if sync is started (e.g. on the device connection page)
    useEffect(() => {
        if (isDeviceSyncInProgress) {
            log.info(`useSyncDevice: Sync is in progress, clearing pending auto-sync, dusn: ${dusn}`);
            setIsSyncPending(false);
        }
    }, [isDeviceSyncInProgress]);
};

export default useSyncDevice;
